import React from "react";
import Download from "../../Components/Download/Download";
import { useState, useEffect } from "react";
import { BASE_URL } from "../../BASE_URL";
import "./Terms.css"

const TermsAndConditions = () => {

  const [Yay, setYay] = useState("")

  const token = localStorage.getItem('token');

  const Call = async () => {
    const res = await fetch(`${BASE_URL}/api/term_and_condition`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });
    const data = await res.json();
    setYay(data.data[0]);
  };

  useEffect(() => {
    Call();
  }, []);


  const stripHTMLTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const plainTextContent = stripHTMLTags(Yay.term_and_condition);

  return (
    <>
    
      <div className="container__wrapper">
        {/* <div>{plainTextContent}</div> */}
        <div className="font-size-h1 ">
          <div className="font-h1-policies" dangerouslySetInnerHTML={{ __html: Yay.term_and_condition }} />
        </div>
        {/* <span>Home &gt; Community Guidelines</span>
        <div className="container">
          <h2 className="container__heading">Terms and Conditions</h2>
          <p>
            Welcome to Betterhalf's Terms and Conditions ("Terms"). This is a
            contract between you and Betterhalf.ai (parent company “Infinite
            forest, Inc.”) and we want you to know your rights before you use
            the Betterhalf application ("App"). Please take a few moments to
            read and understand these Terms before enjoying the App, as once you
            access, view or use the App on desktop or smartphone, you will be
            legally bound by these Terms. You can also refer to our “Privacy
            Policy” to clear all your doubts.
          </p>
          <h3 className="container__heading">1. Betterhalf Rules</h3>
          <p>
            Before using our App, you will need to register with us with an
            account ("Account"). In order to create a verified account, you must
            be:
          </p>
          <h3>At Least 18 years old; and</h3>
          <p>
            Legally permitted to use the App by the laws of your home country.
            <br /> You should have a Facebook account to activate the
            Betterhalf’s account.
            <br />
            You should be a working individual. <br />
            When you create an Account using your Facebook login details, you
            authorize us to access, display and use specific information(s) from
            your Facebook account (e.g. profile picture, relationship status and
            location). For more information about the data we use and how we use
            it, please check our Privacy Policy​​.
          </p>
          <h3>Deleting your account:</h3>
          <p>
            You'll have great connections on Betterhalf, but if you ever feel
            the need to leave, you can delete your Account at any time by going
            to your Profile tab when you are logged in and clicking on the
            'Settings' &gt; "Delete" option. Your Account will be deleted
            immediately and all of your account information will be immediately
            removed from the App. If you wish to login to your account again,
            you will be required to create a fresh account. If you wish to
            deactivate your account for a break, you can click on the deactivate
            option from your profile by clicking on 'Settings' &gt; Deactivate.
            Infinite forest, Inc. reserve the right at our sole discretion to
            suspend any Account, or make use of any operational, technological,
            legal or other means available to enforce the Terms (including
            without limitation blocking specific IP addresses), at any time
            without liability and without the need to give the user prior
            notice.
          </p>
          <p>
            Certain portions of the App may not be accessible if you have not
            registered for a free Account but can unlock the features if you
            upgrade to premium.
          </p>
          <p>
            We do not recommend to share your contact number or bank account
            details unless you wish to do so.
          </p>
          <h3 className="container__heading">2. Types of Content</h3>
          <p>
            There are three types of content that you will be able to access on
            the App:
          </p>
          <p>
            Content that you upload and provide ("Your Content"); <br />
            Content that other members provide ("Member Content"); <br />
            and Content that we provide ("Betterhalf’s Content"). <br />
            There is a certain kind of content we can't allow on Betterhalf:
          </p>
          <p>
            We want our users to be able to express themselves as elaborately as
            possible and post all sorts of things on Betterhalf, but we have to
            impose restrictions on certain content due to our policy. Content
            such as:
          </p>
          <p>
            contains language or imagery which could be deemed offensive or is
            likely to harass, upset, embarrass, alarm or annoy any other person;
            is obscene, sexy, pornographic, violent or otherwise could offend
            human dignity;
            <br />
            is abusive, insulting or threatening, discriminatory or which
            promotes or encourages racism, sexism, hatred or bigotry;
            <br />
            is defamatory or libellous;
            <br />
            relates to industrial activities (including,, sales, competitions
            and advertising, links to different websites or premium line phone
            numbers);
            <br />
            involves the transmission of "junk" mail or "spam";
            <br />
            contains any spy ware, adware, viruses, corrupt files, worm
            programmes or different malicious code designed to interrupt, harm
            or limit the practicality of or disrupt any computer code, hardware,
            telecommunications, networks, servers or different instrumentation,
            computer virus or other material designed to wreck, interfere with,
            wrongly intercept or deprive any information or personal data
            whether or not from Betterhalf or otherwise; itself, or the posting
            of that, infringes any third party's rights (including, while not
            limited to, material possession rights and privacy rights); shows
            another person irregardless that person’s consent.
          </p>
        </div> */}
      </div>
      <Download />
    </>
  );
};

export default TermsAndConditions;
